import React from 'react'
import { Row, Col, Table, Button, Modal, Spin, Popconfirm, notification, Input } from 'antd'
import { UploadOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Query, withApollo } from 'react-apollo'
import moment from 'moment'
import _ from 'lodash'

import {
  UploadParticipants,
  AddParticipant,
  EditParticipant
} from './components'
import CertGenLogo from '../../assets/We_Learn_Banner.png'

import {
  GET_PAGINATED_USER_TOPICS,
  DELETE_USER_TOPIC
} from './qql'

import {
  CapitalizeEveryFirstLetter
} from '../../functions'

import './AdminPage.scss'

var varPageCount = 0  

class AdminPage extends React.Component {
    constructor(props) {
      super(props)

      this.state = {
        show_upload_particants: false,
        uploadedFiles: [],
        processed_data: [],
        uploading: false,
        uploaded: false,
        processing: false,
        uploaded_some: false,

        // Add Attendee
        show_add_attendee: false,
        
        // Table states
        page: 1,
        page_size: 10,
        search: '',

        // Edit Participant entry
        active_entry: null
      }

      this.uploadComponentRef = React.createRef()
      this.addParticipantRef = React.createRef()
      this.editParticipantRef = React.createRef()
      this.bottomDivRef = React.createRef()

    }

    // ----------------- LIFECYCLE ---------------- //
    componentDidMount() {
      // this.scrollToBottom()
    }

    componentDidUpdate() {
      
    }
    // -------------- END OF LIFECYCLE ------------- //

    // ----------------- GRAPHQL --------------- //
    onDeleteUserTopic = (uid) => {
      const { client } = this.props

      client.mutate({
        mutation: DELETE_USER_TOPIC,
        variables: {
          user_topic_uid: uid
        },
        // refetchQueries: this.userTopicsRefetcher()
        refetchQueries: [{
          query: GET_PAGINATED_USER_TOPICS,
          variables: {
            page: this.state.page,
            pageSize: this.state.page_size
          }
        }]
      }).then(res => {
        notification.success({
          message: 'Entry successfully deleted'
        })
      })
    }

    userTopicsRefetcher = () => {
      const toRefetch = []

      for (var i = 0; i < varPageCount + 1; i++) {
          toRefetch.push({
              query: GET_PAGINATED_USER_TOPICS,
              variables:{
                page: i + 1,
                pageSize: 10,
                filter: {
                  search: ''
                }
              }
          })
      }

      return toRefetch
  }
    // ----------------- END of GRAPHQL --------------- //

    scrollToBottom = () => {
      this.bottomDivRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    uploadedFilesSetter = (value) => {
      this.setState({
        uploadedFiles: value
      })
    }

    uploadingSetter = (value) => {
      this.setState({
        uploading: value
      })
    }

    uploadedSetter = (value) => {
      this.setState({
        uploaded: value
      })
    }

    processedDataSetter = (value) => {
      this.setState({
        processed_data: value
      })
    }

    processingSetter = (value) => {
      this.setState({
        processing: value
      })
    }

    showAddAttendeeSetter = (value) => {
      this.setState({
        show_add_attendee: value
      })
    }

    uploadedSomeSetter = (value) => {
      this.setState({
        uploaded_some: value
      })
    }

    tablePageSetter = (value) => {
      this.setState({
        page: value
      })
    }

    tablePageSizeSetter = (value) => {
      this.setState({
        page_size: value
      })
    }

    activeEntrySetter = (value) => {
      this.setState({
        active_entry: value
      })
    }

    onReAdd = () => {
      this.setState({
        uploadedFiles: []
      })
    }

    tableDataManipulator = (list) => {
      const manipulated_data = []

      list.map(item => {

        manipulated_data.push({
          fullname: item.user.username,
          email_address: item.user.email,
          date_attended: moment(item.date_attended).format('LL'),
          topic: item.topic.name,
          data: item
        })
      })

      return manipulated_data
    }

    adminTableSetter = ({ loading, data, error }, columns) => {
      const { page } = this.state

      if(error) return <div>ERROR!</div>
      // if(loading) return <div><Spin/> Loading...</div>
      // const { getUserTopics } = data
      // const { list, pagination } = getUserTopics

      const user_topic_list = data? data.getUserTopics.list? data.getUserTopics.list : [] : []
      let user_topic_pagination = data? data.getUserTopics.pagination? data.getUserTopics.pagination : {} : {}
      user_topic_pagination = Object.assign({}, user_topic_pagination, {
        total: _.has(user_topic_pagination, 'rowCount') ? user_topic_pagination.rowCount : 0,
        showTotal: (total) => `${total} records`,
        current: page,
        defaultCurrent: page,
        onChange: (page, pageSize) => {
          this.setState({
            page: page
          })
        }
      })

      return (
        <div className="admin-page-table__div">
          <Table 
            dataSource={this.tableDataManipulator(user_topic_list)} 
            columns={columns} 
            loading={loading}
            // pagination={{
            //   total: pagination.rowCount,
            //   current: page,
            //   defaultCurrent: page,
            //   onChange: (page, pageSize) => {
            //     this.setState({
            //       page: page
            //     })
            //   },
            //   // showTotal: (total, range) => {
            //   // return <div className="admin-page-table__total-display">{
            //   //   pagination.rowCount > 0?
            //   //   pagination.rowCount > 1?
            //   //   `( ${pagination.rowCount} ) records`
            //   //   : `( ${pagination.rowCount} ) record`
            //   //   : null
            //   //   }</div>
            //   // }
            // }}
            pagination={user_topic_pagination}
          />
        </div>
      )
    }    

    render() {
      const { 
        show_upload_particants, 
        uploadedFiles,
        uploading,
        uploaded,
        processed_data,
        processing,
        show_add_attendee,
        uploaded_some,
        page,
        page_size
      } = this.state

      const columns = [
        {
          title: "Attendee's Name",
          dataIndex: 'fullname',
          key: 'fullname',
          render: (text, record, index) => {
            return (
              <div>
                {text}
              </div>
            )
          }
        },
        {
          title: 'Email Address',
          dataIndex: 'email_address',
          key: 'email_address',
        },
        {
          title: 'Date Attended',
          dataIndex: 'date_attended',
          key: 'date_attended',
        },
        {
          title: 'Topic',
          dataIndex: 'topic',
          key: 'topic',
          render: (text, record, index) => {
            return (
              <div>
                {text}
              </div>
            )
          }
        },
        {
          title: 'Options',
          width: 250,
          render: (text, record, index) => {
      
            return (
              <React.Fragment>
                <Button icon={<EditOutlined />} className="admin-page-table__button--edit"
                  onClick={e => {
                    const active_entry = record.data

                    this.setState({
                      active_entry: {
                        fullname: active_entry.user.username,
                        email_address: active_entry.user.email,
                        date_attended: moment(active_entry.date_attended),
                        topic: active_entry.topic.name,
                        user_topic_uid: active_entry.uid
                      }
                    })
                  }}
                  // disabled
                >Edit</Button>
                <Popconfirm
                  title='Are you sure you want to delete this entry?'
                  onConfirm={e => {
                    this.onDeleteUserTopic(record.data.uid)
                  }}
                >
                  <Button icon={<DeleteOutlined />} className="admin-page-table__button--delete">Delete</Button>
                </Popconfirm>
              </React.Fragment>
            )
          }
        }
      ];
      

      return(
          <div className="admin-page__container">
            <div className="admin-page__logo-div">
              <img 
                  src={CertGenLogo}
                  alt="cert-gen-logo"
                  className="download-page__logo"
              />
            </div>
            <Query
              query={GET_PAGINATED_USER_TOPICS}
              variables={{
                page: page,
                pageSize: page_size,
                filter: {
                  search: this.state.search
                }
              }}
            >
            {({loading, data, error}) => {

                return (
                  <React.Fragment>
                    <Modal
                      visible={show_upload_particants}
                      title='Upload Attendees'
                      closable={false}
                      maskClosable={false}
                      footer={
                        <React.Fragment>
                          <Button
                                  onClick={e => {
                                
                                    if(uploaded_some) {
                                      window.location.reload(false)
                                    } else {
                                      this.setState({
                                        show_upload_particants: false,
                                        uploadedFiles: [],
                                        processed_data: [],
                                        uploading: false,
                                        uploaded: false,
                                        processing: false
                                      })
                                      this.uploadComponentRef.current.wrappedInstance.clearError()
                                      this.uploadComponentRef.current.wrappedInstance.clearBadData()
                                    }
                                  }}
                                  className="admin-page__cancel--button"
                                >
                                  {uploaded? 'Close' : 'Cancel'}
                                </Button>
                                {uploaded?
                                  <Button
                                    type="primary"
                                    className="admin-page__add-users--button"
                                    onClick={e => {
                                      this.setState({
                                        uploadedFiles: [],
                                        processed_data: [],
                                        uploading: false,
                                        uploaded: false,
                                        processing: false
                                      })
                                      this.uploadComponentRef.current.wrappedInstance.clearError()
                                      this.uploadComponentRef.current.wrappedInstance.clearBadData()
                                    }}
                                  >
                                    Add New Files
                                  </Button> :
                                  <Button
                                    type="primary"
                                    className="admin-page__add-users--button"
                                    onClick={e => {
                                      console.log("UPLOAD!")
                                      this.uploadComponentRef.current.wrappedInstance.clearError()
                                  
                                if(uploadedFiles.length > 1) {
                                  console.log('FILES NEED PROCESSING')
                                  this.processingSetter(true)
                                  this.uploadComponentRef.current.wrappedInstance.uploadUsersFromMultipleFiles()
                                } else {
                                  this.uploadingSetter(true)
                                  this.uploadComponentRef.current.wrappedInstance.uploadUser()
                                }
                              }}
                              disabled={uploading || uploadedFiles.length === 0 || processing}
                            >
                              {uploading? 'Uploading...' : 'Upload'}
                            </Button>
                          }
                        </React.Fragment>
                      }
                    >
                      <UploadParticipants
                        ref={this.uploadComponentRef}
                        uploadedFiles={this.state.uploadedFiles}
                        uploadedFilesSetter={this.uploadedFilesSetter}
                        uploadingSetter={this.uploadingSetter}
                        uploading={uploading}
                        uploadedSetter={this.uploadedSetter}
                        uploaded={uploaded}
                        processedDataSetter={this.processedDataSetter}
                        processed_data={processed_data}
                        processingSetter={this.processingSetter}
                        processing={processing}
                        uploadedSomeSetter={this.uploadedSomeSetter}
                      />
                    </Modal>
                    <Modal 
                      visible={show_add_attendee}
                      title={"Add Attendee"}
                      closable={false}
                      maskClosable={false}
                      footer={
                        <React.Fragment>
                          <Button
                            className="admin-page__add-attendee__cancel--button"
                            onClick={e => {
                              this.setState({
                                show_add_attendee: false
                              })
                              this.addParticipantRef.current.wrappedInstance.resetFormFields()
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            className="admin-page__add-attendee__add--button"
                            type="primary"
                            onClick={e => {
                              this.addParticipantRef.current.wrappedInstance.onSubmit()
                            }}
                          >
                            Add
                          </Button>
                        </React.Fragment>
                      }
                    >
                      <AddParticipant
                        ref={this.addParticipantRef}
                        showAddAttendeeSetter={this.showAddAttendeeSetter}
                        tableData={data}
                        page={this.state.page}
                        page_size={this.state.page_size}
                      />
                    </Modal>
                    <Modal
                      visible={this.state.active_entry !== null}
                      title="Edit Participant Entry"
                      closable={false}
                      maskClosable={false}
                      footer={
                        <React.Fragment>
                          <Button
                            onClick={e => {
                              this.editParticipantRef.current.wrappedInstance.clearError()
                              this.setState({
                                active_entry: null
                              })
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="primary"
                            onClick={e => {
                              console.log('Updating...')
                              this.editParticipantRef.current.wrappedInstance.onSubmit()
                            }}
                          >
                            Update
                          </Button>
                        </React.Fragment>
                      }
                    > 
                      <EditParticipant
                        data={this.state.active_entry}
                        ref={this.editParticipantRef}
                        activeEntrySetter={this.activeEntrySetter}
                        tableData={data}
                        page={this.state.page}
                        page_size={this.state.page_size}
                      />
                    </Modal>
                    <Row>
                        <Col 
                            xl={{span: 20, offset: 2}}
                            lg={{span: 20, offset: 2}}
                            md={{span: 20, offset: 2}}
                            sm={{span: 22, offset: 1}}
                            xs={{span: 22, offset: 1}}
                        >
                            <div className="admin-page__participant-list-container">
                                <div className="admin-page__participant-list-label">
                                    <Input
                                      placeholder="Search by full name or email address"
                                      className="admin-page__participant-list__search-input"
                                      value={this.state.search}
                                      onChange={e => {
                                        this.setState({
                                          search: e.target.value,
                                          page: 1
                                        })
                                        this.scrollToBottom()
                                      }}
                                    />
                                    <div className="admin-page__participant-list__header-button-container">
                                      <Button 
                                        className="admin-page__participant-list__header-button--add-user"
                                        onClick={e => {
                                          console.log('Adding attendee...')
                                          this.setState({
                                            show_add_attendee: true
                                          })
                                        }}
                                      >
                                        <PlusOutlined className="admin-page__participant-list__header-button--add-user__icon"/> Add Attendee
                                      </Button>
                                      <Button 
                                        className="admin-page__participant-list__header-button--upload"
                                        onClick={e => {
                                          this.setState({
                                            show_upload_particants: true
                                          })
                                        }}
                                      >
                                        <UploadOutlined className="admin-page__participant-list__header-button--upload__icon"/> Upload Attendees
                                      </Button>
                                    </div>
                                </div>
                                <div className="admin-page__participant-list-table-div">
                                    {this.adminTableSetter({loading, data, error}, columns)}
                                </div>
                                <div ref={this.bottomDivRef} style={{ visibility: 'hidden' }}>
                                  Just used to scroll the page down...
                                </div>
                            </div>
                        </Col>
                    </Row>
                  </React.Fragment>
                )
            }}
            </Query>
          </div>
      )
    }
}

export default withApollo(AdminPage)